'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useSyncExternalStore } from 'react';
const DirectionContext = createContext(undefined);
/** Overrides the resolved direction for a subtree. See the note above. */
export function IconDirectionProvider({ dir, children }) {
    return _jsx(DirectionContext.Provider, { value: dir, children: children });
}
function subscribeToDocumentDirection(onStoreChange) {
    if (typeof document === 'undefined' || typeof MutationObserver === 'undefined') {
        return () => undefined;
    }
    const observer = new MutationObserver(onStoreChange);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['dir'] });
    return () => observer.disconnect();
}
function readDocumentDirection() {
    if (typeof document === 'undefined')
        return 'rtl';
    return document.documentElement.getAttribute('dir') === 'ltr' ? 'ltr' : 'rtl';
}
function readServerDirection() {
    return 'rtl';
}
/**
 * `<html dir>`, kept current.
 *
 * A `MutationObserver` rather than a one-shot read because the theme toggle is
 * not the only thing that writes to `<html>`: AntD's `ConfigProvider`, a future
 * admin "preview in LTR" affordance and the test suite all set `dir` after
 * mount, and an icon that sampled the direction once would be stale.
 */
export function useDocumentDirection() {
    return useSyncExternalStore(subscribeToDocumentDirection, readDocumentDirection, readServerDirection);
}
/** The direction an icon should resolve against. `override` wins if given. */
export function useIconDirection(override) {
    const fromContext = useContext(DirectionContext);
    const fromDocument = useDocumentDirection();
    return override ?? fromContext ?? fromDocument;
}
//# sourceMappingURL=direction.js.map